import injectSheet from 'react-jss'
import ErrorMessage from './ErrorMessage'
import styles from './ErrorMessage.styles'

export default injectSheet(styles)(ErrorMessage)
